import { Grid } from '@mui/material';
import { Checkbox, VSpacer } from '@nx-smartmonkey/ui';

import { PropsWithChildren } from 'react';
import Text from '../../../../../react-components/Text';

interface CheckboxOptionPillProps {
  text: string;
  info?: string;
  selected?: boolean;
  showCheckbox?: boolean;
  style?: React.CSSProperties;
  onSelect?: (selected: boolean) => void;
}

export const CheckboxOptionPill = ({
  text,
  info,
  selected = false,
  showCheckbox = true,
  onSelect,
  style = {},
  children,
}: PropsWithChildren<CheckboxOptionPillProps>) => {
  return (
    <Grid container direction="column">
      <Grid
        container
        wrap="nowrap"
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        style={{
          border: `1px solid #E0E0E0`,
          borderRadius: `2px`,
          padding: `8px`,
          margin: `4px 0`,
          minHeight: `42px`,
          ...style,
        }}
      >
        <Grid item container direction="column">
          <Grid item>
            <Text variant={!selected ? `label` : `body`} style={{ fontSize: `13px` }}>
              {text}
            </Text>
          </Grid>
          {info ? (
            <>
              <VSpacer small />
              <Grid item>
                <Text variant="label" style={{ fontSize: `10px` }}>
                  {info}
                </Text>
              </Grid>
            </>
          ) : null}
        </Grid>
        {showCheckbox ? (
          <Grid item>
            <Checkbox checked={selected} onChange={(e) => onSelect?.(e.target.checked)} />
          </Grid>
        ) : null}
      </Grid>
      {children}
    </Grid>
  );
};
